import { render, staticRenderFns } from "./ScreenPage.vue?vue&type=template&id=6085289f&scoped=true&"
import script from "./ScreenPage.vue?vue&type=script&lang=js&"
export * from "./ScreenPage.vue?vue&type=script&lang=js&"
import style0 from "./ScreenPage.vue?vue&type=style&index=0&id=6085289f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085289f",
  null
  
)

export default component.exports